const trackEvent = (category, action, label, value) => {
	if (!('ga' in window) || !category || !action) return;

	ga('send', 'event', category, action, label, value);
};

export default trackEvent;
